import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { SharedModule } from '../_shared/_shared.module';

@NgModule({
    declarations: [MainComponent],
    imports: [CommonModule, MainRoutingModule, SharedModule],
    exports: []
})
export class MainModule {}
